import { useEffect, useState } from "react"
import { User } from "../../../../types/gqlTypes/graphql"
import { findUsersGlobal } from "../../../../services/generic-services/org"
import { useSearchDropdownManage } from "../../../mp-shared-components/generic-shared-components/components/SearchWithDropdown/hooks"

const MIN_SEARCH_LENGTH = 3

export const useGlobalSearchData = () => {
  const {
    loading,
    searchInput,
    debouncedSearchInput,
    isNarrowSearch,
    loadingSetter,
    searchInputSetter,
    isNarrowSearchSetter
  } = useSearchDropdownManage()

  const [searchedUsers, setSearchedUsers] = useState<User[]>([])

  const onSearchInputChange = (value: string) => searchInputSetter(value)
  const clearSearchInput = () => searchInputSetter("")

  const getUsers = async (search: string) => {
    const isNarrowSearch = search.length < MIN_SEARCH_LENGTH

    if (isNarrowSearch) {
      isNarrowSearchSetter(isNarrowSearch)
      return
    }

    loadingSetter(true)

    try {
      const { users: searchedUsers, hasMoreResults } = await findUsersGlobal({
        search
      })

      setSearchedUsers(searchedUsers)
      isNarrowSearchSetter(hasMoreResults)
    } catch (error) {
      setSearchedUsers([])
    } finally {
      loadingSetter(false)
    }
  }

  useEffect(() => {
    setSearchedUsers([])

    if (!debouncedSearchInput) return

    getUsers(debouncedSearchInput)
  }, [debouncedSearchInput])

  return {
    loading,
    searchInput,
    debouncedSearchInput,
    searchedUsers: !loading && !isNarrowSearch ? searchedUsers : [],
    isNarrowSearch,
    onSearchInputChange,
    clearSearchInput
  }
}
